import React from "react";
import loadable from "@loadable/component";
import Layout from "../../../components/Layout/layout";
import SEO from "../../../components/seo";
import {
  appointmentsHero,
  appointmentsTrusted,
  appointmentsWhiteGlove,
  appointmentsLargeFeatures,
  appointmentsBusinessTypesCar,
  // appointmentsVideo,
  appointmentsSolutionsSection,
  appointmentsTestimonials,
  appointmentsCTA,
  appointmentsSolutionsSlides,
  // appointmentsFaqs,
} from "../../../data/product-pages/appointments-data";
import Hero from "../../../components/Hero/hero";
// import TrustedNumbers from "../../../components/TrustedNumbers/TrustedNumbers";
// import WhiteGlove from "../../../components/WhiteGlove/WhiteGlove";
// import LargeFeatures from "../../../components/LargeFeatures/LargeFeatures";
// import BusinessTypes from "../../../components/BusinessTypes/BusinessTypes";
// import PartnerLogos from "../../../components/PartnerLogos/PartnerLogos";
// import TestmonialReviews from "../../../components/TestimonialReviews/TestmonialReviews";
// import LargeCta from "../../../components/CTAs/LargeCta";
// import ProductLines from "../../../components/ProductLines/ProductLines";
// import SuccessStories from "../../../components/SuccessStories/SuccessStories";
import { hbBTSlides, heroSuccess } from "../../../data/success-stories-data";
import ogImage from "../../../images/global_assets/og-image.png";

const TrustedNumbers = loadable(() =>
  import("../../../components/TrustedNumbers/TrustedNumbers")
);
const WhiteGlove = loadable(() =>
  import("../../../components/WhiteGlove/WhiteGlove")
);
const LargeFeatures = loadable(() =>
  import("../../../components/LargeFeatures/LargeFeatures")
);
const BusinessTypes = loadable(() =>
  import("../../../components/BusinessTypes/BusinessTypes")
);
const PartnerLogos = loadable(() =>
  import("../../../components/PartnerLogos/PartnerLogos")
);
const TestmonialReviews = loadable(() =>
  import("../../../components/TestimonialReviews/TestmonialReviews")
);
const LargeCta = loadable(() => import("../../../components/CTAs/LargeCta"));
const ProductLines = loadable(() =>
  import("../../../components/ProductLines/ProductLines")
);
const SuccessStories = loadable(() =>
  import("../../../components/SuccessStories/SuccessStories")
);

const whiteGloveImport = "appointments-whote-glove.png";

const appointments = () => {
  return (
    <Layout>
      <SEO
        title="POS Appointment Scheduling Software | Book More Appointments | SpotOn"
        description="Book more appointments with SpotOn's POS appointment scheduling software. Simplify appointment booking, employee scheduling, & checkout. Get a demo!"
        image={`https://spoton.com/${ogImage}`}
        cannonical="https://www.spoton.com/products/appointments/"
      />
      <Hero sectionData={appointmentsHero} circleBg={false} />
      <TrustedNumbers numbersArray={appointmentsTrusted} />
      <WhiteGlove
        sectionData={appointmentsWhiteGlove}
        whiteGloveBg={whiteGloveImport}
      />
      <LargeFeatures
        sectionData={appointmentsLargeFeatures}
        style={{ marginTop: "128px" }}
      />
      <BusinessTypes sectionData={appointmentsBusinessTypesCar} />
      <SuccessStories sectionData={heroSuccess} slides={hbBTSlides} />
      <PartnerLogos />
      <ProductLines
        sectionData={appointmentsSolutionsSection}
        productSlides={appointmentsSolutionsSlides}
      />
      <TestmonialReviews sectionData={appointmentsTestimonials} />
      <PartnerLogos />
      <LargeCta sectionData={appointmentsCTA} />
      {/* <Faqs sectionData={appointmentsFaqs} /> */}
    </Layout>
  );
};

export default appointments;
